<template>
    <span>
         <span v-show="enabled">
             <slot :scope="scope"></slot>
             <div style="display: none" class="storage">
                <div class="layui-form layui-card-header layuiadmin-card-header-auto">
                    <div class="layui-inline"><label class="layui-search-label">文件名称</label></div>
                    <div class="layui-inline" style="width:130px">
                        <input
                          class="layui-input"
                          autocomplete="off"
                          v-model="storage.queryObject['S_ORIGINAL_NAME:2']"
                          placeholder="请输入文件名称"
                        />
                    </div>
                    <div class="layui-inline"><label class="layui-search-label">资料名称</label></div>
                    <div class="layui-inline" style="width:130px">
                        <input
                          class="layui-input"
                          autocomplete="off"
                          v-model="storage.queryObject['STORAGE_NAME:2']"
                          placeholder="请输入资料名称"
                        />
                    </div>
                    <button class="layui-btn layuiadmin-btn-list" @click="$refs.storage.search()" title="查询">查询</button>
                    <button class="layui-btn" @click="$refs.storage.reset() " title="重置">重置</button>
                </div>
                <layui-table
                  ref="storage"
                  table-name="YW_STORAGE_V2"
                  :renderRow="renderStorageRow"
                  :afterLoad="storageAfterLoad"
                  :lazy="true"
                  :page-size="20"
                  :page-range="6"
                  :page-options="[10, 20, 50, 100]"
                  :skin="'line'"
                  :sort="['STORAGE_NAME:DESC']"
                  height="320"
                  @table-event-preview="storagePreview($event)"
                >
                    <div>
                        <div checkbox="true" align="center" fixed="left" width="60"></div>
                        <div field="S_ORIGINAL_NAME" title="文件名称" align="center" width="220"></div>
                        <div field="STORAGE_NAME" title="所属资料" align="center"></div>
                        <div field="BRAND_NAME" title="所属品牌" align="center"></div>
                        <div field="S_TYPE" title="类型" align="center" width="80"></div>
                        <div field="S_SIZE" title="大小" align="center" width="80"></div>
                        <div align="center" toolbar title="操作" width="80">
                            <script type="text/html">
                                <a class="layui-btn-xs" lay-event="preview">预览</a>
                            </script>
                        </div>
                    </div>
                </layui-table>
                <div style="text-align: center;margin-top: 20px;">
                    <button class="layui-btn layuiadmin-btn-list" @click="handleStorage()" title="上传">上传</button>
                    <button class="layui-btn layuiadmin-btn-list" @click="layer.closePop(storageElId)"
                            title="关闭">关闭</button>
                </div>
             </div>
         </span>
         <div
           class="layui-form layui-border-box layui-table-view layui-listFileUpload" style="margin-top:10px"
         >
            <div class="layui-table-box" v-show="docs.length">
                <div class="layui-table-header">
                <table
                  style="width: 100%;border: 1px solid #ccc;"
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  class="layui-table"
                >
                    <thead>
                    <tr>
                        <th style="width:5%;">
                        <div class="layui-table-cell">
                            <span>序号</span>
                        </div>
                        </th>
                        <th style="width:55%;">
                        <div class="layui-table-cell" style="text-align:center">
                            <a>附件名称</a>
                        </div>
                        </th>
                        <th style="width:10%;">
                        <div class="layui-table-cell" style="text-align:center">
                            <span>类型</span>
                        </div>
                        </th>
                        <th style="width:10%;">
                        <div class="layui-table-cell" style="text-align:center">
                            <span>大小</span>
                        </div>
                        </th>
                        <th style="width:20%;">
                        <div class="layui-table-cell" style="text-align:center">
                            <span>操作</span>
                        </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody style="text-align: center">
                    <tr v-for="(file,index) in docs" v-bind:key="file.DOCUMENT_ID" style="height: 35px">
                        <td>
                            <div>{{ index + 1 }}</div>
                        <td>
                            <div v-if="file.TYPE == '文件' && file.S_TYPE != 'mp4'">
                                <a style="color:black;cursor:pointer">{{ file.S_ORIGINAL_NAME }}</a>
                            </div>
                            <div v-if="file.TYPE == '文件' && file.S_TYPE == 'mp4'">
                                <a style="color:black;cursor:pointer" @click="preView(file);" >{{ file.S_ORIGINAL_NAME }}</a>
                            </div>
                            <div v-if="file.TYPE == '图片'">
                                <span><a class="thumbImg" style="color:black;cursor:pointer" :data-id="file.DOCUMENT_ID"
                                         :data-caption="file.S_ORIGINAL_NAME" :data-group="id" data-magnify="gallery"
                                         :data-src="file.src">{{ file.S_ORIGINAL_NAME }}</a>
                                </span>
                            </div>
                        </td>
                        <td>
                            <div>{{ file.TYPE }}</div>
                        </td>
                         <td>
                            <div>{{ getSize(file) }}</div>
                        </td>
                        <td>
                            <div>
                                <a class="layui-btn-xs" @click="preView(file);" style="height: 25px;line-height: 25px;">预览</a>
                                <a class="layui-btn-xs" @click="getFile(file.src);"
                                   style="height: 25px;line-height: 25px;">下载</a>
                                <a v-show="enabled" class="layui-btn-xs layui-btn-xs-danger"
                                   @click="deleteFile(file.DOCUMENT_ID)" style="height: 25px;line-height: 25px;">删除</a>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
         <LayuiVideo
           v-if="showVideoStatus"
           :videoFile="videoFile"
           :showVideoStatus.sync="showVideoStatus"
           @closeVideo="closeVideo()"
         />
     </span>
</template>
<script>
import "../../../static/plugin/plupload/queue/css/jquery.plupload.queue.css";
import "../../../static/plugin/plupload/plupload.js"
import "../../../static/plugin/plupload/queue/jquery.plupload.queue.js"
import "../../../static/plugin/plupload/plupload.html4.js"
import "../../../static/plugin/plupload/plupload.html5.js"
import "../../../static/plugin/plupload/plupload.flash.js"
import "../../../static/plugin/plupload/zh_CN.js"
import LayuiVideo from "@/components/common/LayuiVideo";

export default {
  name: 'LayuiListFileUpload',
  components: {LayuiVideo},
  props: {
    requestUniqueId: {
      type: String, // // 请求唯一标识，必须有
      default: () => {
        return 'LayuiListFileUpload-' + window.uuid();
      },
    },
    _model: {
      default: '',
      required: false
    },
    enabled: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    uploadTitle: {
      type: String,
    },
    filters: {
      type: Array,
      default: () => {
        return []
      }
    },
    max: {
      type: Number,
      default: -1
    },
    targetEl: {
      type: String
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    }
  },
  model: {
    prop: '_model',
    event: '_modelEvent'
  },
  data() {
    return {
      id: null,
      scope: this,
      fileNum: 0,
      docs: [],
      fileList: [],
      showStorage: false,
      showVideoStatus: false,
      videoFile: {S_ORIGINAL_NAME: 'sasa'},
      storage: {
        queryObject: {},
        checkedRows: []
      }
    }
  },
  mounted() {
    var element = this.el = $(this.$el);
    var id = this.id = this.uuid();
    this.tid = this.security.getUser().getToken();
    this.url = process.env.REPOSITORY_HOST + '/file/preViewUpload?token=' + this.tid;
    //如果有默认值，处理加载，一般是页面组件data有默认值
    if (this._model) {
      this.setValue(this._model);
    }
  },
  methods: {
    closeVideo() {
      this.showVideoStatus = false
    },
    setUrl(newUrl) {
      this.url = newUrl;
    },
    upload() {
      if (this.fileNum == this.max) {
        this.layer.openAlert("只允许上传" + this.max + "个文件!");
        return;
      }
      var that = this;
      $("#" + this.id).remove();
      this.el.find('.layuiupload').attr("id", this.id);
      var uploadEl = this.getUploadTemplate();
      uploadEl = $(uploadEl);
      uploadEl.attr('id', this.id);
      $("body").append(uploadEl);
      this.layer.openPop(this.id, this.uploadTitle ? this.uploadTitle : '上传文件', 600, 380, true);
      uploadEl.find(".filePlace").pluploadQueue({
        runtimes: 'html5,flash',
        url: that.url,
        unique_names: true,
        filters: this.filters.length > 0 ? [{title: "", extensions: this.filters.join(",")}] : "",
        init: {
          FileUploaded: function (uploader, file, response) {
            if (response.response) {
              var result = JSON.parse(response.response);
              if (result.error) {
                console.error(result.error);
              } else {
                var addDoc = result.doc;
                var obj = {};
                for (var p in addDoc) {
                  obj[p.toUpperCase()] = addDoc[p];
                }
                that.fileNum++;
                that.docs.push(that.wrapFile(obj));
                that.ui_update = true;
                that.$emit('uploadComplete', result);
                that.$emit('_modelEvent', that.buildValue());
                that.$nextTick(() => {
                  that.renderPictureView(".thumbImg");
                })
              }
              that.layer.closePop(that.id)
            }
          },
          UploadComplete: function (uploader, fs) {
            uploader.refresh();
            uploader.destroy();//ie9以下若不销毁此对象第二次上传会十分缓慢
          },
          FilesAdded: function (uploader, files) {
            if (that.max > 0 && that.fileNum + uploader.files.length > that.max) {
              while (uploader.files.length > 0) {
                uploader.removeFile(uploader.files[0]);
              }
              that.layer.openAlert("只允许上传" + that.max + "个文件!");
              return;
            }
          },
        }
      });
    },
    getUploadTemplate() {
      return `<div class="layuiupload"style="display: none;">
                        <div class="filePlace"></div>
                        </div>
                    </div>`
    },
    deleteFile(docId) {
      this.layer.openConfirm('确定要删除这个文件吗?', () => {
        for (var i = 0; i < this.docs.length; i++) {
          var doc = this.docs[i];
          if (doc.DOCUMENT_ID == docId) {
            this.docs.remove(doc);
            this.ui_update = true;
            this.$emit('_modelEvent', this.buildValue());
            return;
          }
        }
      });
    },
    buildValue() {
      var value = [];
      for (var i = 0; i < this.docs.length; i++) {
        var doc = this.docs[i];
        value.push(doc.DOCUMENT_ID);
      }
      return value.join(",");
    },
    setValue(value) {
      if (!this.ui_update) {
        if (!value) {
          this.docs = [];
        } else {
          this.api.queryList(
            'DB_DOCUMENT',
            {p2: {'DOCUMENT_ID:1': value}},
            this.requestUniqueId
          ).then(response => {
            var results = response.result;
            for (var i = 0; i < results.length; i++) {
              var result = results[i];
              if (!this.containsDoc(result.DOCUMENT_ID)) {
                this.docs.push(this.wrapFile(result));
              }
            }
            this.fileNum = results.length;
            this.$nextTick(() => {
              this.renderPictureView(".thumbImg");
            });
          });
        }
      }
      this.ui_update = false;
      this.fileNum = this.docs.length;
    },
    renderPictureView(className) {
      this.el.find(className).Magnify({
        Toolbar: [
          'prev',
          'next',
          'rotateLeft',
          'rotateRight',
          'zoomIn',
          'actualSize',
          'zoomOut'
        ],
        keyboard: true,
        draggable: true,
        movable: true,
        modalSize: [800, 600],
      });
    },
    containsDoc(docId) {
      for (var i = 0; i < this.docs.length; i++) {
        var doc = this.docs[i];
        if (doc.DOCUMENT_ID == docId) {
          return true;
        }
      }
    },
    wrapFile(file) {
      file.TYPE = this.isImg(file) ? '图片' : '文件';
      file.src = process.env.REPOSITORY_HOST + '/file/get/' + file.DOCUMENT_ID + '?token=' + this.tid;
      file.pdfSrc = process.env.REPOSITORY_HOST + '/file/getPdf/' + file.DOCUMENT_ID + '?token=' + this.tid;
      file.wordSrc = process.env.REPOSITORY_HOST + '/file/getPreView/' + file.DOCUMENT_ID + '?token=' + this.tid;
      return file;
    },
    getFile(src) {
      window.open(src);
    },
    showPdf(file, src) {
      var target = $(this.targetEl);
      $(".fileList_showpdf").remove();
      let content = $(`<div class="fileList_showpdf" style="width:100%;height:100%">
                        <iframe type="application/pdf" style='width:100%;height:100%'></iframe>
                    </div>`);
      content.find("iframe").attr("src", src);
      let id = window.uuid();
      content.attr("id", id);
      target.append(content);
      var that = this;
      this.layer.openConfigPop({
        popId: id,
        title: file.S_ORIGINAL_NAME,
        width: this.width ? this.width : target.width() * 0.7,
        height: this.height ? this.height : 700,
        targetEl: target,
        colseCB: function (idx, layero) {
          $(".fileList_showpdf").remove();
          that.layui.layer.close(idx);
          layero.remove();
        }
      });
    },
    preView(file) {
      debugger
      if (this.isPdf(file)) {
        // this.showPdf(file, file.pdfSrc);
        // window.open(file.pdfSrc)
        this.layer.openAlert('该文件格式不支持预览，请下载后查看');
      } else if (this.isWord(file) || this.isPPT(file)) {
        // window.open(file.wordSrc)
        // this.showPdf(file, file.wordSrc);
        this.layer.openAlert('该文件格式不支持预览，请下载后查看');
      } else if (this.isExcel(file)) {
        // window.open(file.wordSrc)
        // this.showPdf(file, file.wordSrc);
        this.layer.openAlert('该文件格式不支持预览，请下载后查看');
      } else if (this.isImg(file)) {
        $('[data-id=' + file.DOCUMENT_ID + ']').trigger('click');
      } else if (this.isVideo(file)) {
        // this.layer.openAlert('视频格式');
        this.showVideoStatus = true
        this.videoFile = file
        console.log(this.videoFile);
      } else {
        this.layer.openAlert('该文件格式不支持预览，请下载后查看');
      }
    },
    isVideo(file) {
      var type = file.S_TYPE;
      return type.toLowerCase() == 'mp4';
    },
    isPdf(file) {
      var type = file.S_TYPE;
      return type.toLowerCase() == 'pdf';
    },
    isWord(file) {
      var type = file.S_TYPE;
      return type.toLowerCase().indexOf('doc') >= 0;
    },
    isExcel(file) {
      var type = file.S_TYPE;
      return type.toLowerCase().indexOf('xls') >= 0;
    },
    isPPT(file) {
      var type = file.S_TYPE;
      return type.toLowerCase().indexOf('ppt') >= 0;
    },
    isImg(file) {
      var type = file.S_TYPE;
      var imgTypes = ["jpg", "jpeg", "png", "bmp", "tiff", "gif", "psd"];
      for (var i = 0; i < imgTypes.length; i++) {
        var imgTypeName = imgTypes[i];
        if (imgTypeName == type.toLowerCase()) {
          return true;
        }
      }
    },
    getSize(file) {
      var size = file.S_SIZE;
      if (size) {
        if (size > 1000 * 100) {
          return (size / 1000 / 1000).toFixed(1) + 'MB';
        } else {
          return (size / 1000).toFixed(1) + 'KB';
        }
      }
    },
    uploadFromStorage() {
      var target = $(this.targetEl);
      this.storage = this.$refs.storage;
      this.storage.load();
      this.storageElId = this.uuid();
      this.el.find('.storage').attr('id', this.storageElId);
      this.layer.openConfigPop({
        popId: this.storageElId,
        title: '资料库文件',
        width: this.width ? this.width : target.width() * 0.8,
        height: this.height ? this.height : 650,
        targetEl: target,
      });
    },
    storagePreview($event) {
      var file = $event.data;
      this.preView(file);
    },
    renderStorageRow(row) {
      row.S_SIZE = this.getSize(row);
      row.DOCUMENT_ID = row.DOCUMENTID;
      this.wrapFile(row);
      if (row.TYPE == '图片') {
        row.S_ORIGINAL_NAME = '<span><a class="thumbImg_storage" style="color:black;cursor:pointer" data-id="' + row.DOCUMENT_ID + '" \
                                    data-caption="' + row.S_ORIGINAL_NAME + '"  data-magnify="gallery"  data-src="' + row.src + '">' + row.S_ORIGINAL_NAME + '</a>\
                                </span>'
      }
    },
    storageAfterLoad() {
      this.renderPictureView(".thumbImg_storage");
      var modelStr = this._model + '';
      var arr = modelStr ? modelStr.split(',') : [];
      this.storage.data.forEach((e) => {
        for (var i = 0; i < arr.length; i++) {
          if (e['DOCUMENTID'] == arr[i]) {
            this.storage.checkRow(e);
            this.storage.checkedRows.push(e);
            break;
          }
        }
      });
    },
    handleStorage() {
      if (this.storage.checkedRows.length == 0) {
        this.layer.openAlert('请至少选择一个文件！');
        return;
      }
      this.layer.openConfirm('确定要上传吗?', () => {
        var storageArr = [];
        this.storage.checkedRows.forEach((e) => {
          storageArr.push(e.DOCUMENT_ID);
        });
        if (this._model) {
          storageArr = [...storageArr, ...this._model.split(',')]
        }
        //做个去重
        var set = {};
        storageArr.forEach((e) => {
          set[e] = 1;
        })
        storageArr = [];
        for (var key in set) {
          storageArr.push(key);
        }
        this.$emit('_modelEvent', storageArr.join(','));
        this.layer.closePop(this.storageElId)
      });
    }
  },
  watch: {
    _model(value) {
      this.setValue(value);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiListFileUpload.vue